<template>
	<div>
		<el-form-item label="Name" :prop="`${prop}.name`" :rules="rules.name">
			<el-input :value="name" @input="$emit('update:name', $event)"/>
		</el-form-item>
		<el-form-item label="Title" :prop="`${prop}.title`" :rules="rules.title">
			<el-input :value="title" @input="$emit('update:title', $event)"/>
		</el-form-item>
		<el-form-item label="Phone" :prop="`${prop}.phone`" :rules="rules.phone">
			<el-input type="tel" prefix-icon="el-icon-phone" :value="phone" @input="$emit('update:phone', $event)" v-mask="'(###) ###-####'"/>
		</el-form-item>
		<el-form-item label="Email" :prop="`${prop}.email`"  :rules="rules.email">
			<el-input type="email" prefix-icon="el-icon-message" :value="email" @input="$emit('update:email', $event)"/>
		</el-form-item>
	</div>
</template>

<script>
import { mapSimpleValidation, mapEmailValidation, mapPhoneValidation } from '@/js/utilities/validation-mapper.js';
export default{
	props: ['name', 'title', 'phone', 'email', 'prop'],
	data() {
		return {
			rules: {
				...mapSimpleValidation(['name', 'title']),
				...mapPhoneValidation(['phone']),
				...mapEmailValidation(['email'])
			}
		}
	}
}
</script>
